import type { ReactNode } from 'react';
import { Trans } from 'react-i18next';

import { Text } from '@actual-app/components/text';

import { Boton } from '#components/mobile/ui/Boton';
import { abrirTripulacion } from '#components/pareja/abrirTripulacion';
import { useCompartir } from '#components/pareja/useCompartir';
import { useMetadataPref } from '#hooks/useMetadataPref';
import { useDispatch } from '#redux';

import { Setting } from './UI';

/**
 * Ajustes → «Compartir»: qué es compartir según quién mira y «Ver la
 * tripulación», la misma pantalla que abre el puerto.
 */
export function CompartirSettings() {
  const dispatch = useDispatch();
  const { soloLectura, puedeCompartir, aBordo, cloudFileId } = useCompartir();
  const [budgetName] = useMetadataPref('budgetName');

  if (!cloudFileId || !(soloLectura || puedeCompartir || aBordo)) {
    return null;
  }

  const verTripulacion = (
    <Boton
      data-testid="ver-tripulacion"
      data-al-mando={puedeCompartir || undefined}
      onPress={() => dispatch(abrirTripulacion(cloudFileId, budgetName ?? ''))}
    >
      <Trans>See the crew</Trans>
    </Boton>
  );

  let explicacion: ReactNode;
  if (soloLectura) {
    explicacion = (
      <Trans>
        <strong>Shared with you to view only</strong>: you can look at this
        budget, but nothing you change is saved. Ask its owner if you need to
        edit it.
      </Trans>
    );
  } else if (puedeCompartir) {
    explicacion = (
      <Trans>
        <strong>Share budget</strong>: choose who else can open this budget.
        With <strong>View only</strong> they can look at everything but nothing
        they change is saved. With <strong>View and edit</strong> they can
        change it just like you.
      </Trans>
    );
  } else {
    explicacion = (
      <Trans>
        <strong>You are aboard</strong>: this budget belongs to someone else and
        you share it with them. If you get off, it is removed from this phone
        and what you added stays in the plan.
      </Trans>
    );
  }

  return (
    <Setting primaryAction={verTripulacion}>
      <Text>{explicacion}</Text>
    </Setting>
  );
}
